import { POSTS_PREVIEW_QUERY_RESULT } from "@/types/sanity.types";
import styles from "./PostCard.module.scss";
import { RESPONSIVE_SIZES, SanityImage } from "../SanityImage";
import FormattedDate from "../post/FormattedDate";
import Tags from "../post/Tags";
import clsx from "clsx";
import { Tag } from "@silversea-ssc/ui-components-react";
import Link from "next/link";
import { AlgoliaPost } from "@repo/algolia/types";

export type PostCardVariant = "horizontal" | "vertical" | "auto";
export type PostCardProps = {
  post: AlgoliaPost | POSTS_PREVIEW_QUERY_RESULT[number];
  variant: PostCardVariant;
  darkMode?: boolean;
};

const PostCard: React.FC<PostCardProps> = ({
  post,
  variant = "auto",
  darkMode = false
}) => {
  const {
    featuredMedia,
    title,
    authors,
    publishDate,
    tags = [],
    mainCategory
  } = post;
  const authorsList = authors.map((author) => author.name).join(", ");
  const firstThreeTags = tags?.slice(0, 3) ?? [];
  return (
    <Link href={post.slug || "#"} className={styles.title}>
      <article
        className={clsx(styles.container, {
          [styles.auto]: variant === "auto",
          [styles.vertical]: variant === "vertical",
          [styles.horizontal]: variant === "horizontal",
          [styles.darkMode]: darkMode
        })}
      >
        <header className={styles.header}>
          {featuredMedia && (
            <SanityImage
              image={featuredMedia}
              alt={title || "Article featured image"}
              aspectRatio="card"
              fill
              sizes={RESPONSIVE_SIZES.card}
              className={styles.image}
            />
          )}
        </header>
        <Tag
          backgroundColor={darkMode ? "titaniumDark" : "white"}
          className={styles.category}
          size="large"
        >
          {mainCategory}
        </Tag>
        <div className={styles.content}>
          <h4 className={styles.title}>{title}</h4>
          <div className={styles.authors}>{authorsList}</div>
          {publishDate && <FormattedDate date={publishDate} />}
        </div>

        {tags && tags.length > 0 && (
          <footer className={styles.footer}>
            <Tags
              backgroundColor={darkMode ? "titanium" : undefined}
              tags={firstThreeTags}
              className={styles.tags}
            />
          </footer>
        )}
      </article>
    </Link>
  );
};

export default PostCard;
